// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__S7Eok","spin":"Spinner_spin__6s2qE"};